import React from "react";
import { IPostIngestionDatesResult } from "../../interface/IPostIngestionDates";
import { formatDateTimeToReadable } from "../../utils/commonUtils";

type Props = {
  data: IPostIngestionDatesResult | null;
};

const formatIngestionDay = (dateString: string): string => {
  const [year, month, day] = dateString.split("-").map(Number);
  const date = new Date(Date.UTC(year, month - 1, day));

  return date.toLocaleDateString("en-IN", {
    weekday: "short",
    day: "2-digit",
    month: "short",
    year: "numeric",
    timeZone: "Asia/Kolkata",
  });
};

const PostIngestionDatesPanel: React.FC<Props> = ({ data }) => {
  const rows = data?.ingestionDates ?? [];

  return (
    <article className="bg-white rounded-2xl border border-light shadow-sm p-5">
      <p className="text-xs uppercase tracking-wide text-tertiary mb-1">
        Posts table — ingestion calendar
      </p>
      <p className="text-sm text-secondary mb-4">
        Last {data?.limit ?? 5} distinct days when posts were stored (IST).
        Weekend gaps are expected when the cron is inactive.
      </p>

      {rows.length === 0 ? (
        <p className="text-sm text-tertiary">No ingestion dates found.</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-light text-left text-tertiary">
                <th className="py-3 pr-4 font-medium">Ingestion day</th>
                <th className="py-3 pr-4 font-medium">Posts stored</th>
                <th className="py-3 font-medium">Latest stored at</th>
              </tr>
            </thead>
            <tbody>
              {rows.map(row => (
                <tr
                  key={row.date}
                  className="border-b border-light last:border-b-0"
                >
                  <td className="py-3 pr-4 text-primary font-medium">
                    {formatIngestionDay(row.date)}
                  </td>
                  <td className="py-3 pr-4 text-secondary">
                    {row.postCount.toLocaleString()}
                  </td>
                  <td className="py-3 text-secondary">
                    {formatDateTimeToReadable(row.latestCreatedAt)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </article>
  );
};

export default PostIngestionDatesPanel;
